<template>
  <div class="declare_view">
    <h2>1、报告说明</h2>
    <h3>1.1、考试内容</h3>
    <!-- <div class="mian_view" v-for="(item, index) in tableData" :key="index">
      <div>{{ item.label }}</div>
      <div>{{item.value}}</div>
    </div> -->
    <div class="table_view">
      <table class="mian_view">
        <tr v-for="(item, index) in tableData" :key="index">
          <th class="ts">{{ item.label }}</th>
          <th class="gray">{{ item.value }}</th>
        </tr>
      </table>
    </div>
    <!-- 第二部分 -->
    <div class="eaxm_general">
      <h2>2、考试概况</h2>
      <p>
        总考试人数 <span>{{ $parent.ExamList.allUserCount }}人</span>; 已考人数
        <span>{{ $parent.ExamList.AlreadyStuCount }}人</span>, 末考人数<span
          >{{ $parent.ExamList.NoStuCount }}人</span
        >, 其中满分人数<span>{{ $parent.ExamList.fullStuCount }}人</span>,
        及格人数<span>{{ $parent.ExamList.PassStuCount }}人</span>, 及格率<span
          >{{
            (
              ($parent.ExamList.PassStuCount /
                $parent.ExamList.AlreadyStuCount) *
              100
            ).toFixed(2)
          }}%</span
        >; 未及格人数 <span>{{ $parent.ExamList.NoPassStuCount }}人</span>。
      </p>
      <p class="case">考试成绩分布情况</p>
      <div class="table_view">
        <el-table
          :data="countData"
          border
          style="width: 100%"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
            'text-align': 'center',
          }"
        >
          <el-table-column prop="grade" label="成绩"> </el-table-column>
          <el-table-column prop="nun" label="人数"> </el-table-column>
          <el-table-column prop="Proportion" label="占比">
            <template slot-scope="scope">
              <p>{{ scope.row.Proportion }}%</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <DepartSon ref="sonf" />
    </div>
  </div>
</template>

<script>
import { create } from "js-md5";
import DepartSon from "./DepartSon.vue";
import { option } from "./charts";
export default {
  props: ["ExamList"],
  components: {
    DepartSon,
  },
  data() {
    return {
      tableData: [
        {
          label: "考试名称",
          value: "ExamName",
        },
        {
          label: "考试时间",
          value: "ExamTime",
        },
        {
          label: "题目数量",
          value: "TestCount",
        },
        {
          label: "答题时长",
          value: "SpendTime",
        },
        {
          label: "总分",
          value: "TotalScore",
        },
        {
          label: "及格分",
          value: "PassScore",
        },
        {
          label: "总考试人数",
          value: "allUserCount",
        },
        {
          label: "已考人数",
          value: "AlreadyStuCount",
        },
        {
          label: "未考人数",
          value: "NoStuCount",
        },
        {
          label: "满分人数",
          value: "fullStuCount",
        },
        {
          label: "及格人数",
          value: "PassStuCount",
        },
        {
          label: "不及格人数",
          value: "NoPassStuCount",
        },
        {
          label: "最高分",
          value: "MaxScore",
        },
        {
          label: "最低分",
          value: "MinScore",
        },
      ],
      countData: [
        {
          grade: "", // 成绩
          nun: "", // 及格
          Proportion: "", // 不及格
        },
        {
          grade: "",
          nun: "",
          Proportion: "",
        },
        {
          grade: "",
          nun: "",
          Proportion: "",
        },
      ],
    };
  },
  methods: {
    fn() {
      this.tableData.map((item) => {
        for (let i in this.$parent.ExamList) {
          if (item.value == i) {
            item.value = this.$parent.ExamList[i];
            console.log("进来了");
            // this.$set(item, "key", this.ExamList[i]);
          }
        }
      });
      // 处理第二步考试概况
      let total =
        this.$parent.ExamList.fullStuCount +
        this.$parent.ExamList.PassStuCount +
        this.$parent.ExamList.NoPassStuCount; // 总数
      this.countData[0].grade = `满分(${this.$parent.ExamList.TotalScore})`; // 满分
      this.countData[0].nun = this.$parent.ExamList.fullStuCount; // 满分人数
      this.countData[0].Proportion = (
        (this.$parent.ExamList.fullStuCount / total) *
        100
      ).toFixed(2); // 满分人数占比
      this.countData[1].grade = `及格(${this.$parent.ExamList.PassScore})`; // 及格
      this.countData[1].nun = this.$parent.ExamList.PassStuCount; // 及格人数
      this.countData[1].Proportion = (
        (this.$parent.ExamList.PassStuCount / total) *
        100
      ).toFixed(2); // 及格人数占比
      this.countData[2].grade = `不及格(小于${this.$parent.ExamList.PassScore})`; // 不及格
      this.countData[2].nun = this.$parent.ExamList.NoPassStuCount;
      this.countData[2].Proportion = (
        (this.$parent.ExamList.NoPassStuCount / total) *
        100
      ).toFixed(2); // 及格人数占比
    },
    //首页饼状图的接口 ===》 饼状图的渲染
    async reportData() {
     
      this.$nextTick(() => {
        option.series[0].data = this.countData.map((item) => {
          item.grade1 = item.grade.split("(")[0];
          return {
            name: item.grade1 + item.Proportion + "%", // v满分
            value: item.Proportion, // 占比
          };
        });
      
        this.$refs.sonf.init(option);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.declare_view {
  h3 {
    margin-top: 10px;
  }
  .mian_view {
    margin-top: 24px;
    border-spacing: 1px;
    background-color: black;
    td,
    th {
      background-color: white;
    }
    th {
      width: 800px;
      height: 40px;
      letter-spacing: 2px;
    }
    .gray {
      color: #666 !important;
      font-size: 16px;
      font-weight: normal;
    }
  }
}
.ts {
  width: 300px !important;
}
.table_view {
  padding: 0px 300px;
}
.eaxm_general {
  margin-top: 24px;
  p {
    margin-top: 24px;
    span {
      color: red;
    }
  }
  .case {
    text-align: center;
    margin-top: 26px;
    margin-bottom: 22px;
  }
}
::v-deep .el-table th.el-table__cell > .cell {
  text-align: center;
}
::v-deep .el-table td.el-table__cell div {
  text-align: center;
}
::v-deep .el-table .cell {
  text-align: center;
  // margin-bottom: ;
}
</style>